export const env = {
  COMMUNITY_URL: process.env.COMMUNITY_URL,
  DEBUG: process.env.DEBUG === 'true',
};
